export default __webpack_public_path__ + "static/media/logout.59338420.svg";